'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _l10n = require('../../../common/l10n');

var _l10n2 = _interopRequireDefault(_l10n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var _this = this;

    var classList = this.compileStyle(_index2.default),
        input = null,
        items = null,
        label = null,
        selected = this._getSelected(),
        mask = null;

    if (this._preparedList.length) {
        items = [];
        var itemContent = void 0;

        this._preparedList.forEach(function (item, i) {
            var isReactComponent = _react2.default.isValidElement(item.name),
                stringName = isReactComponent ? _l10n2.default.translate(item.stringName) : _l10n2.default.translate(item.name);

            items.push(_react2.default.createElement('input', {
                id: _this.state.id + i,
                type: 'radio',
                className: classList.field,
                checked: item.id === (selected && selected.id),
                value: item.id,
                name: _this.state.id,
                onChange: _this.props.onChange,
                key: 'item-' + i,
                'data-qa-node': _this.props.attribute + '-option',
                'data-qa-value': stringName
            }));

            if (isReactComponent) {
                itemContent = item.name;
            } else {
                itemContent = stringName;
            }

            items.push(_react2.default.createElement(
                'label',
                {
                    className: classList.fieldLabel,
                    htmlFor: _this.state.id + i, key: 'label-' + i,
                    ref: _this._labelRef.bind(_this),
                    'data-id': item.id,
                    title: stringName
                },
                itemContent
            ));
        });

        if (this.props.label) {
            label = _react2.default.createElement(
                'div',
                { className: classList.label },
                this.props.label
            );
        }

        if (selected && selected.id) {
            var selectedContent = void 0,
                isReactComponent = _react2.default.isValidElement(selected.name),
                stringName = isReactComponent ? _l10n2.default.translate(selected.stringName) : _l10n2.default.translate(selected.name);

            if (isReactComponent) {
                selectedContent = selected.name;
            } else {
                selectedContent = stringName;
            }

            mask = _react2.default.createElement(
                'div',
                {
                    className: classList.mask,
                    style: this._getMaskPosition(selected),
                    title: stringName,
                    'data-qa-node': this.props.attribute,
                    'data-qa-value': stringName
                },
                selectedContent
            );
        }

        input = _react2.default.createElement(
            'div',
            { className: classList.input },
            _react2.default.createElement(
                'div',
                { className: classList.wrapper, ref: this._listRef.bind(this) },
                mask,
                items
            )
        );
    }

    return _react2.default.createElement(
        'div',
        {
            ref: this._rootRef.bind(this),
            className: classList.root + ' ' + (this.props.className || '')
        },
        label,
        input
    );
}